
import { Component, Mixins } from "vue-property-decorator";
import { IWizardContent, instanceOfIWizardContentsContainable } from "../../../../../../../domain/format";
import { default as ContentMixin } from "./ContentMixin.vue";

@Component
export default class ContentContainerMixin extends Mixins(ContentMixin) {
  get contents(): IWizardContent[] {
    return instanceOfIWizardContentsContainable(this.content)
      ? this.content.contents
      : [];
  }

  get containerStyle() {
    return {
      // disable時の背景色は親任せなので透過する.
      background: this.disabled
        ? "rgba(255, 255, 255, 0)"
        : "#FFFFFF",
      gap: (instanceOfIWizardContentsContainable(this.content) && !!this.content.gap ? this.content.gap : "0"),
    };
  }

  get contentStyle() {
    return {
      margin: (instanceOfIWizardContentsContainable(this.content) && !!this.content.contentMargin ? this.content.contentMargin : "1vmin"),
    };
  }
}
